module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4_IT-3b692b4b1ffc055cc5dafc4b7deac5ad.svg";